import { render } from "./NumberDisplay.vue?vue&type=template&id=445c47d1&scoped=true"
import script from "./NumberDisplay.vue?vue&type=script&lang=js"
export * from "./NumberDisplay.vue?vue&type=script&lang=js"

import "./NumberDisplay.vue?vue&type=style&index=0&id=445c47d1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\benme\\Documents\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-445c47d1"]])

export default __exports__